import { render, staticRenderFns } from "./AmThucList.vue?vue&type=template&id=3cfe5403"
import script from "./AmThucList.vue?vue&type=script&lang=js"
export * from "./AmThucList.vue?vue&type=script&lang=js"
import style0 from "./AmThucList.vue?vue&type=style&index=0&id=3cfe5403&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports